//#region ../../node_modules/.pnpm/@mui+utils@7.3.9_@types+react@19.2.14_react@19.2.4/node_modules/@mui/utils/esm/formatMuiErrorMessage/formatMuiErrorMessage.js
function e(e, ...t) {
	let n = new URL(`https://mui.com/production-error/?code=${e}`);
	return t.forEach((e) => n.searchParams.append("args[]", e)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
//#endregion
export { e as default };

//# sourceMappingURL=index13.js.map